// extracted by mini-css-extract-plugin
export default {"bubble":"style--bubble--69ed57"};